import axios from "axios"
import { EuConstructionVatAccountsState } from "../../components/accountingPlan/EuConstructionVatAccounts"
import { buyOrSell } from "../../utils/company"
import { Dispatch, RNBThunkAction } from "../store.config"

export const enum CompanySettingsActionsEnum {
  SELECT_COMPANY = "COMPANY_SETTINGS/selectCompany",

  GET_COMPANY_VAT_ACCOUNTS_SETTINGS_ATTEMPT = "COMPANY_SETTINGS/getCompanyVatAccountsSettingsAttempt",
  GET_COMPANY_VAT_ACCOUNTS_SETTINGS_SUCCESS = "COMPANY_SETTINGS/getCompanyVatAccountsSettingsSuccess",
  GET_COMPANY_VAT_ACCOUNTS_SETTINGS_ERROR = "COMPANY_SETTINGS/getCompanyVatAccountsSettingsError",
  DISABLE_VAT_ACCOUNTS_ATTEMPT = "COMPANY_SETTINGS/disableVatAccountsAttempt",
  DISABLE_VAT_ACCOUNTS_SUCCESS = "COMPANY_SETTINGS/disableVatAccountsSuccess",
  DISABLE_VAT_ACCOUNTS_ERROR = "COMPANY_SETTINGS/disableVatAccountsError",
  CREATE_VAT_ACCOUNTS_ATTEMPT = "COMPANY_SETTINGS/createVatAccountsAttempt",
  CREATE_VAT_ACCOUNTS_SUCCESS = "COMPANY_SETTINGS/createVatAccountsSuccess",
  CREATE_VAT_ACCOUNTS_ERROR = "COMPANY_SETTINGS/createVatAccountsError",

  CREATE_ACCOUNT_ATTEMPT = "COMPANY_SETTINGS/createAccountAttempt",
  CREATE_ACCOUNT_SUCCESS = "COMPANY_SETTINGS/createAccountSuccess",
  CREATE_ACCOUNT_ERROR = "COMPANY_SETTINGS/createAccountError",
  CREATE_ACCOUNT_DUPLICATE_ERROR = "COMPANY_SETTINGS/createAccountDuplicateError",
  CREATE_ACCOUNT_RESET = "COMPANY_SETTINGS/createAccountReset",
  CREATE_ACCOUNT_SUCCESS_TOASTER = "COMPANY_SETTINGS/createAccountSuccessToaster",

  GET_MY_UNISOFT_TOKEN_ATTEMPT = "COMPANY_SETTINGS/getMyUnisoftTokenAttempt",
  GET_MY_UNISOFT_TOKEN_SUCCESS = "COMPANY_SETTINGS/getMyUnisoftTokenSuccess",
  GET_MY_UNISOFT_TOKEN_ERROR = "COMPANY_SETTINGS/getMyUnisoftTokenError",

  UPDATE_MY_UNISOFT_TOKEN_ATTEMPT = "COMPANY_SETTINGS/updateMyUnisoftTokenAttempt",
  UPDATE_MY_UNISOFT_TOKEN_SUCCESS = "COMPANY_SETTINGS/updateMyUnisoftTokenSuccess",
  UPDATE_MY_UNISOFT_TOKEN_ERROR = "COMPANY_SETTINGS/updateMyUnisoftTokenError",

  GET_COMPANY_EU_CONSTRUCTION_VAT_ACCOUNTS_SETTINGS_ATTEMPT = "COMPANY_SETTINGS/getCompanyEuConstructionVatAccountsSettingsAttempt",
  GET_COMPANY_EU_CONSTRUCTION_VAT_ACCOUNTS_SETTINGS_SUCCESS = "COMPANY_SETTINGS/getCompanyEuConstructionVatAccountsSettingsSuccess",
  GET_COMPANY_EU_CONSTRUCTION_VAT_ACCOUNTS_SETTINGS_ERROR = "COMPANY_SETTINGS/getCompanyEuConstructionVatAccountsSettingsError",

  CREATE_EU_CONSTRUCTION_VAT_ACCOUNTS_ATTEMPT = "COMPANY_SETTINGS/createEuConstructionVatAccountsAttemptAction",
  CREATE_EU_CONSTRUCTION_VAT_ACCOUNTS_SUCCESS = "COMPANY_SETTINGS/createEuConstructionVatAccountsSuccessAction",
  CREATE_EU_CONSTRUCTION_VAT_ACCOUNTS_ERROR = "COMPANY_SETTINGS/createEuConstructionVatAccountsErrorAction",

  UPDATE_EU_CONSTRUCTION_VAT_ACCOUNTS_ATTEMPT = "COMPANY_SETTINGS/updateEuConstructionVatAccountsAttemptAction",
  UPDATE_EU_CONSTRUCTION_VAT_ACCOUNTS_SUCCESS = "COMPANY_SETTINGS/updateEuConstructionVatAccountsSuccessAction",
  UPDATE_EU_CONSTRUCTION_VAT_ACCOUNTS_ERROR = "COMPANY_SETTINGS/updateEuConstructionVatAccountsErrorAction",

  GET_COMPANY_EU_CONSTRUCTION_VAT_ACCOUNTS_HISTORY_ATTEMPT = "COMPANY_SETTINGS/getCompanyEuConstructionVatAccountsHistoryAttempt",
  GET_COMPANY_EU_CONSTRUCTION_VAT_ACCOUNTS_HISTORY_SUCCESS = "COMPANY_SETTINGS/getCompanyEuConstructionVatAccountsHistorySuccess",
  GET_COMPANY_EU_CONSTRUCTION_VAT_ACCOUNTS_HISTORY_ERROR = "COMPANY_SETTINGS/getCompanyEuConstructionVatAccountsHistoryError",

  GET_COMPANY_GOODS_TRANSFER_ACCOUNTS_ATTEMPT = "COMPANY_SETTINGS/GetCompanyGoodsTransferAccountsAttempt",
  GET_COMPANY_GOODS_TRANSFER_ACCOUNTS_SUCCESS = "COMPANY_SETTINGS/GetCompanyGoodsTransferAccountsSuccess",
  GET_COMPANY_GOODS_TRANSFER_ACCOUNTS_FAILURE = "COMPANY_SETTINGS/GetCompanyGoodsTransferAccountsFailure",

  UPDATE_GOODS_TRANSFER_ACCOUNTS_ATTEMPT = "COMPANY_SETTINGS/UpdateGoodsTransferAccountsAttempt",
  UPDATE_GOODS_TRANSFER_ACCOUNTS_SUCCESS = "COMPANY_SETTINGS/UpdateGoodsTransferAccountsSuccess",
  UPDATE_GOODS_TRANSFER_ACCOUNTS_FAILURE = "COMPANY_SETTINGS/UpdateGoodsTransferAccountsFailure",
  UPDATE_GOODS_TRANSFER_ACCOUNTS_RESET = "COMPANY_SETTINGS/UpdateGoodsTransferAccountsReset",

  CREATE_GOODS_TRANSFER_ACCOUNT_ATTEMPT = "COMPANY_SETTINGS/CreateGoodsTransferAccountAttempt",
  CREATE_GOODS_TRANSFER_ACCOUNT_SUCCESS = "COMPANY_SETTINGS/CreateGoodsTransferAccountSuccess",
  CREATE_GOODS_TRANSFER_ACCOUNT_FAILURE = "COMPANY_SETTINGS/CreateGoodsTransferAccountFailure",
  CREATE_GOODS_TRANSFER_ACCOUNT_RESET = "COMPANY_SETTINGS/CreateGoodsTransferAccountReset",

  CREATE_GOODS_TRANSFER_ACCOUNT_WITH_VAT_ATTEMPT = "COMPANY_SETTINGS/CreateGoodsTransferAccountWithVatAttempt",
  CREATE_GOODS_TRANSFER_ACCOUNT_WITH_VAT_SUCCESS = "COMPANY_SETTINGS/CreateGoodsTransferAccountWithVatSuccess",
  CREATE_GOODS_TRANSFER_ACCOUNT_WITH_VAT_FAILURE = "COMPANY_SETTINGS/CreateGoodsTransferAccountWithVatFailure",

  DESTROY_COMMISSION_ACCOUNT_VAT_RATE_ATTEMPT = "COMPANY_SETTINGS/DestroyCommissionAccountVatRateAttempt",
  DESTROY_COMMISSION_ACCOUNT_VAT_RATE_SUCCESS = "COMPANY_SETTINGS/DestroyCommissionAccountVatRateSuccess",
  DESTROY_COMMISSION_ACCOUNT_VAT_RATE_FAILURE = "COMPANY_SETTINGS/DestroyCommissionAccountVatRateFailure",

  GET_DATA_TO_UPDATE_ACCOUNTING_SOFTWARE_ATTEMPT = "COMPANY_SETTINGS/GetDataToUpdateAccountingSoftwareAttempt",
  GET_DATA_TO_UPDATE_ACCOUNTING_SOFTWARE_SUCCESS = "COMPANY_SETTINGS/GetDataToUpdateAccountingSoftwareSuccess",
  GET_DATA_TO_UPDATE_ACCOUNTING_SOFTWARE_FAILURE = "COMPANY_SETTINGS/GetDataToUpdateAccountingSoftwareFailure",
}

export const createAccountDuplicateError = () =>
  ({
    type: CompanySettingsActionsEnum.CREATE_ACCOUNT_DUPLICATE_ERROR,
    withToast: true,
    toasterType: "error",
    message: {
      titleKey: `office-company-settings.vat-accounts.account-creation-error-title`,
      bodyKey: `office-company-settings.vat-accounts.account-creation-error-body`,
    },
  } as const)

export const createAccountSuccessToaster = () =>
  ({
    type: CompanySettingsActionsEnum.CREATE_ACCOUNT_SUCCESS_TOASTER,
    withToast: true,
    toasterType: "success",
    message: {
      titleKey: `office-company-settings.vat-accounts.account-creation-success-title`,
      bodyKey: `office-company-settings.vat-accounts.account-creation-success-body`,
    },
  } as const)

export const getCompanyVatAccountsSettingsAttemptAction = () =>
  ({
    type: CompanySettingsActionsEnum.GET_COMPANY_VAT_ACCOUNTS_SETTINGS_ATTEMPT,
  } as const)
export const getCompanyVatAccountsSettingsErrorAction = () =>
  ({
    type: CompanySettingsActionsEnum.GET_COMPANY_VAT_ACCOUNTS_SETTINGS_ERROR,
  } as const)

export const getCompanyVatAccountsSettingsSuccessAction = (
  vatAccounts: VatAccounts
) =>
  ({
    type: CompanySettingsActionsEnum.GET_COMPANY_VAT_ACCOUNTS_SETTINGS_SUCCESS,
    payload: vatAccounts,
  } as const)

export const disableVatAccountsAttemptAction = () =>
  ({
    type: CompanySettingsActionsEnum.DISABLE_VAT_ACCOUNTS_ATTEMPT,
  } as const)
export const disableVatAccountsErrorAction = () =>
  ({
    type: CompanySettingsActionsEnum.DISABLE_VAT_ACCOUNTS_ERROR,
  } as const)
export const disableVatAccountsSuccessAction = () =>
  ({
    type: CompanySettingsActionsEnum.DISABLE_VAT_ACCOUNTS_SUCCESS,
  } as const)

export const createVatAccountsAttemptAction = () =>
  ({
    type: CompanySettingsActionsEnum.CREATE_VAT_ACCOUNTS_ATTEMPT,
  } as const)
export const createVatAccountsErrorAction = () =>
  ({
    type: CompanySettingsActionsEnum.CREATE_VAT_ACCOUNTS_ERROR,
  } as const)
export const createVatAccountsSuccessAction = () =>
  ({
    type: CompanySettingsActionsEnum.CREATE_VAT_ACCOUNTS_SUCCESS,
  } as const)

export const createAccountAttemptAction = () =>
  ({
    type: CompanySettingsActionsEnum.CREATE_ACCOUNT_ATTEMPT,
  } as const)
export const createAccountResetAction = () =>
  ({
    type: CompanySettingsActionsEnum.CREATE_ACCOUNT_RESET,
  } as const)
export const createAccountErrorAction = () =>
  ({
    type: CompanySettingsActionsEnum.CREATE_ACCOUNT_ERROR,
  } as const)
export const createAccountSuccessAction = (createdAccount: CreatedAccount) =>
  ({
    type: CompanySettingsActionsEnum.CREATE_ACCOUNT_SUCCESS,
    payload: { createdAccount },
  } as const)

export const getMyUnisoftTokenAttemptAction = () =>
  ({
    type: CompanySettingsActionsEnum.GET_MY_UNISOFT_TOKEN_ATTEMPT,
  } as const)
export const getMyUnisoftTokenErrorAction = () =>
  ({
    type: CompanySettingsActionsEnum.GET_MY_UNISOFT_TOKEN_ERROR,
  } as const)
export const getMyUnisoftTokenSuccessAction = (myUnisoftToken: string) =>
  ({
    type: CompanySettingsActionsEnum.GET_MY_UNISOFT_TOKEN_SUCCESS,
    payload: { myUnisoftToken },
  } as const)

export const updateMyUnisoftTokenAttemptAction = () =>
  ({
    type: CompanySettingsActionsEnum.UPDATE_MY_UNISOFT_TOKEN_ATTEMPT,
  } as const)
export const updateMyUnisoftTokenErrorAction = () =>
  ({
    type: CompanySettingsActionsEnum.UPDATE_MY_UNISOFT_TOKEN_ERROR,
  } as const)
export const updateMyUnisoftTokenSuccessAction = (myUnisoftToken: string) =>
  ({
    type: CompanySettingsActionsEnum.UPDATE_MY_UNISOFT_TOKEN_SUCCESS,
    payload: { myUnisoftToken },
  } as const)

export const getCompanyEuConstructionVatAccountsSettingsAttemptAction = () =>
  ({
    type: CompanySettingsActionsEnum.GET_COMPANY_EU_CONSTRUCTION_VAT_ACCOUNTS_SETTINGS_ATTEMPT,
  } as const)
export const getCompanyEuConstructionVatAccountsSettingsErrorAction = () =>
  ({
    type: CompanySettingsActionsEnum.GET_COMPANY_EU_CONSTRUCTION_VAT_ACCOUNTS_SETTINGS_ERROR,
  } as const)

export const getCompanyEuConstructionVatAccountsSettingsSuccessAction = (
  euConstructionVatAccounts: EuConstructionVatAccountSettings
) =>
  ({
    type: CompanySettingsActionsEnum.GET_COMPANY_EU_CONSTRUCTION_VAT_ACCOUNTS_SETTINGS_SUCCESS,
    payload: euConstructionVatAccounts,
  } as const)

export const createEuConstructionVatAccountsAttemptAction = () =>
  ({
    type: CompanySettingsActionsEnum.CREATE_EU_CONSTRUCTION_VAT_ACCOUNTS_ATTEMPT,
  } as const)
export const createEuConstructionVatAccountsErrorAction = () =>
  ({
    type: CompanySettingsActionsEnum.CREATE_EU_CONSTRUCTION_VAT_ACCOUNTS_ERROR,
  } as const)
export const createEuConstructionVatAccountsSuccessAction = (
  createdEuConstructionVatAccount: CreatedEuConstructionVatAccount
) =>
  ({
    type: CompanySettingsActionsEnum.CREATE_EU_CONSTRUCTION_VAT_ACCOUNTS_SUCCESS,
    payload: { createdEuConstructionVatAccount },
  } as const)

export const updateEuConstructionVatAccountsAttemptAction = () =>
  ({
    type: CompanySettingsActionsEnum.UPDATE_EU_CONSTRUCTION_VAT_ACCOUNTS_ATTEMPT,
  } as const)
export const updateEuConstructionVatAccountsErrorAction = () =>
  ({
    type: CompanySettingsActionsEnum.UPDATE_EU_CONSTRUCTION_VAT_ACCOUNTS_ERROR,
  } as const)
export const updateEuConstructionVatAccountsSuccessAction = () =>
  ({
    type: CompanySettingsActionsEnum.UPDATE_EU_CONSTRUCTION_VAT_ACCOUNTS_SUCCESS,
  } as const)

export const getCompanyEuConstructionVatAccountsHistoryAttemptAction = () =>
  ({
    type: CompanySettingsActionsEnum.GET_COMPANY_EU_CONSTRUCTION_VAT_ACCOUNTS_HISTORY_ATTEMPT,
  } as const)
export const getCompanyEuConstructionVatAccountsHistoryErrorAction = () =>
  ({
    type: CompanySettingsActionsEnum.GET_COMPANY_EU_CONSTRUCTION_VAT_ACCOUNTS_HISTORY_ERROR,
  } as const)

export const getCompanyEuConstructionVatAccountsHistorySuccessAction = ({
  userAccountInstructions,
  vatType,
}: {
  userAccountInstructions: Instructions[]
  vatType: vatType
}) =>
  ({
    type: CompanySettingsActionsEnum.GET_COMPANY_EU_CONSTRUCTION_VAT_ACCOUNTS_HISTORY_SUCCESS,
    payload: { userAccountInstructions, vatType },
  } as const)

export const selectCompanyAction = () =>
  ({
    type: CompanySettingsActionsEnum.SELECT_COMPANY,
  } as const)

export const GetCompanyGoodsTransferAccountsAttempt = () =>
  ({
    type: CompanySettingsActionsEnum.GET_COMPANY_GOODS_TRANSFER_ACCOUNTS_ATTEMPT,
  } as const)
export const GetCompanyGoodsTransferAccountsSuccess = (
  goodsPayload: GoodsTransfer,
  accountNumberLimit: number | null,
  vat_rates: Rate[]
) =>
  ({
    type: CompanySettingsActionsEnum.GET_COMPANY_GOODS_TRANSFER_ACCOUNTS_SUCCESS,
    goodsPayload,
    accountNumberLimit,
    vat_rates,
  } as const)
export const GetCompanyGoodsTransferAccountsFailure = () =>
  ({
    type: CompanySettingsActionsEnum.GET_COMPANY_GOODS_TRANSFER_ACCOUNTS_FAILURE,
  } as const)

export const UpdateGoodsTransferAccountsAttempt = () =>
  ({
    type: CompanySettingsActionsEnum.UPDATE_GOODS_TRANSFER_ACCOUNTS_ATTEMPT,
  } as const)
export const UpdateGoodsTransferAccountsSuccess = () =>
  ({
    type: CompanySettingsActionsEnum.UPDATE_GOODS_TRANSFER_ACCOUNTS_SUCCESS,
  } as const)
export const UpdateGoodsTransferAccountsFailure = () =>
  ({
    type: CompanySettingsActionsEnum.UPDATE_GOODS_TRANSFER_ACCOUNTS_FAILURE,
  } as const)
export const UpdateGoodsTransferAccountsReset = () =>
  ({
    type: CompanySettingsActionsEnum.UPDATE_GOODS_TRANSFER_ACCOUNTS_RESET,
  } as const)

export const CreateGoodsTransferAccountAttempt = () =>
  ({
    type: CompanySettingsActionsEnum.CREATE_GOODS_TRANSFER_ACCOUNT_ATTEMPT,
  } as const)
export const CreateGoodsTransferAccountSuccess = (
  newAccount: AccountGoodsTransfer
) =>
  ({
    type: CompanySettingsActionsEnum.CREATE_GOODS_TRANSFER_ACCOUNT_SUCCESS,
    newAccount,
    withToast: true,
    toasterType: "warning",
    message: {
      titleKey: `accounting-plan.goods-transfer.modal-create-success.title`,
      bodyKey: `accounting-plan.goods-transfer.modal-create-success.message`,
    },
  } as const)
export const CreateGoodsTransferAccountFailure = () =>
  ({
    type: CompanySettingsActionsEnum.CREATE_GOODS_TRANSFER_ACCOUNT_FAILURE,
  } as const)
export const CreateGoodsTransferAccountReset = () =>
  ({
    type: CompanySettingsActionsEnum.CREATE_GOODS_TRANSFER_ACCOUNT_RESET,
  } as const)

export const CreateGoodsTransferAccountWithVatAttempt = () =>
  ({
    type: CompanySettingsActionsEnum.CREATE_GOODS_TRANSFER_ACCOUNT_WITH_VAT_ATTEMPT,
  } as const)
export const CreateGoodsTransferAccountWithVatSuccess = (
  commissions: CommissionAccountVatRate[],
  goodsType: string
) =>
  ({
    type: CompanySettingsActionsEnum.CREATE_GOODS_TRANSFER_ACCOUNT_WITH_VAT_SUCCESS,
    commissions,
    goodsType,
  } as const)
export const CreateGoodsTransferAccountWithVatFailure = () =>
  ({
    type: CompanySettingsActionsEnum.CREATE_GOODS_TRANSFER_ACCOUNT_WITH_VAT_FAILURE,
  } as const)

export const DestroyCommissionAccountVatRateAttempt = () =>
  ({
    type: CompanySettingsActionsEnum.DESTROY_COMMISSION_ACCOUNT_VAT_RATE_ATTEMPT,
  } as const)
export const DestroyCommissionAccountVatRateSuccess = (
  commissions: CommissionAccountVatRate[],
  goodsType: string
) =>
  ({
    type: CompanySettingsActionsEnum.DESTROY_COMMISSION_ACCOUNT_VAT_RATE_SUCCESS,
    commissions,
    goodsType,
    withToast: true,
    toasterType: "success",
    message: {
      titleKey: `accounting-plan.goods-transfer.destroy-commission.success.title`,
      bodyKey: `accounting-plan.goods-transfer.destroy-commission.success.message`,
    },
  } as const)
export const DestroyCommissionAccountVatRateFailure = () =>
  ({
    type: CompanySettingsActionsEnum.DESTROY_COMMISSION_ACCOUNT_VAT_RATE_FAILURE,
    withToast: true,
    toasterType: "error",
    message: {
      titleKey: `accounting-plan.goods-transfer.destroy-commission.error.title`,
      bodyKey: `accounting-plan.goods-transfer.destroy-commission.error.message`,
    },
  } as const)

export const GetDataToUpdateAccountingSoftwareAttempt = () =>
  ({
    type: CompanySettingsActionsEnum.GET_DATA_TO_UPDATE_ACCOUNTING_SOFTWARE_ATTEMPT,
  } as const)
export const GetDataToUpdateAccountingSoftwareSuccess = (
  data: ResponseDataUpdateAccountingSoftware
) =>
  ({
    type: CompanySettingsActionsEnum.GET_DATA_TO_UPDATE_ACCOUNTING_SOFTWARE_SUCCESS,
    data,
  } as const)
export const GetDataToUpdateAccountingSoftwareFailure = () =>
  ({
    type: CompanySettingsActionsEnum.GET_DATA_TO_UPDATE_ACCOUNTING_SOFTWARE_FAILURE,
  } as const)

export type CompanySettingsActionsType = ReturnType<
  | typeof getCompanyVatAccountsSettingsAttemptAction
  | typeof getCompanyVatAccountsSettingsSuccessAction
  | typeof getCompanyVatAccountsSettingsErrorAction
  | typeof disableVatAccountsAttemptAction
  | typeof disableVatAccountsSuccessAction
  | typeof disableVatAccountsErrorAction
  | typeof createVatAccountsAttemptAction
  | typeof createVatAccountsSuccessAction
  | typeof createVatAccountsErrorAction
  | typeof createAccountAttemptAction
  | typeof createAccountErrorAction
  | typeof createAccountSuccessAction
  | typeof createAccountResetAction
  | typeof createAccountDuplicateError
  | typeof getMyUnisoftTokenAttemptAction
  | typeof getMyUnisoftTokenErrorAction
  | typeof getMyUnisoftTokenSuccessAction
  | typeof updateMyUnisoftTokenAttemptAction
  | typeof updateMyUnisoftTokenErrorAction
  | typeof updateMyUnisoftTokenSuccessAction
  | typeof getCompanyEuConstructionVatAccountsSettingsAttemptAction
  | typeof getCompanyEuConstructionVatAccountsSettingsSuccessAction
  | typeof getCompanyEuConstructionVatAccountsSettingsErrorAction
  | typeof createEuConstructionVatAccountsAttemptAction
  | typeof createEuConstructionVatAccountsErrorAction
  | typeof createEuConstructionVatAccountsSuccessAction
  | typeof updateEuConstructionVatAccountsAttemptAction
  | typeof updateEuConstructionVatAccountsErrorAction
  | typeof updateEuConstructionVatAccountsSuccessAction
  | typeof getCompanyEuConstructionVatAccountsHistoryAttemptAction
  | typeof getCompanyEuConstructionVatAccountsHistorySuccessAction
  | typeof getCompanyEuConstructionVatAccountsHistoryErrorAction
  | typeof createAccountSuccessToaster
  | typeof selectCompanyAction
  | typeof GetCompanyGoodsTransferAccountsAttempt
  | typeof GetCompanyGoodsTransferAccountsSuccess
  | typeof GetCompanyGoodsTransferAccountsFailure
  | typeof UpdateGoodsTransferAccountsAttempt
  | typeof UpdateGoodsTransferAccountsSuccess
  | typeof UpdateGoodsTransferAccountsFailure
  | typeof UpdateGoodsTransferAccountsReset
  | typeof CreateGoodsTransferAccountAttempt
  | typeof CreateGoodsTransferAccountSuccess
  | typeof CreateGoodsTransferAccountFailure
  | typeof CreateGoodsTransferAccountReset
  | typeof CreateGoodsTransferAccountWithVatAttempt
  | typeof CreateGoodsTransferAccountWithVatSuccess
  | typeof CreateGoodsTransferAccountWithVatFailure
  | typeof DestroyCommissionAccountVatRateAttempt
  | typeof DestroyCommissionAccountVatRateSuccess
  | typeof DestroyCommissionAccountVatRateFailure
  | typeof GetDataToUpdateAccountingSoftwareAttempt
  | typeof GetDataToUpdateAccountingSoftwareSuccess
  | typeof GetDataToUpdateAccountingSoftwareFailure
>

export const companySettingsInitialState: CompanySettingsState = {
  rates: [],
  possibleBuyAccounts: [],
  possibleSellAccounts: [],
  selectedAccounts: [],
  assignMode: "no_vat",
  accountNumberLimit: null,
  createdAccount: null,
  myUnisoftToken: "",
  createdEuConstructionVatAccount: null,
  construction_vat: {
    selected_account: null,
    possible_accounts: [],
    prefix: [],
    forbid: [],
  },
  construction_reverse_vat: {
    selected_account: null,
    possible_accounts: [],
    prefix: [],
    forbid: [],
  },
  eu_vat: {
    selected_account: null,
    possible_accounts: [],
    prefix: [],
    forbid: [],
  },
  eu_reverse_vat: {
    selected_account: null,
    possible_accounts: [],
    prefix: [],
    forbid: [],
  },
  goods_transfer: {
    commission_account_vat_rates: {},
    enum_translations: null,
    goods_transfer_commission_type_enum: [],
    goods_transfer_type_enum: [],
    possible_goods_transfer_accounts: [],
    possible_goods_transfer_commission_accounts: [],
    selected_accounts: null,
    goods_transfer_rules: [],
    goods_transfer_commission_rules: [],
  },
  createdGoodsTransferAccount: null,
  updatedGoodsTransferStatus: "idle",
  dataToUpdateAccountingSoftware: {
    length_rules: {
      max_account_number_length: null,
      max_code_length: null,
    },
    codes_too_long: [],
    accounts_too_long: [],
    all_accounts: [],
    all_codes: [],
    accounting_software_prefix: null,
    auxiliary_or_principal: null,
    software_events: [],
  },
}

export interface CompanySettingsState {
  rates: Rate[]
  possibleBuyAccounts: Account[]
  possibleSellAccounts: Account[]
  selectedAccounts: SelectedAccount[]
  assignMode: VatAssignMode
  accountNumberLimit: number | null
  createdAccount: CreatedAccount | null
  myUnisoftToken: string
  createdEuConstructionVatAccount: CreatedEuConstructionVatAccount | null
  construction_vat: EuConstructionVatAccounts
  construction_reverse_vat: EuConstructionVatAccounts
  eu_vat: EuConstructionVatAccounts
  eu_reverse_vat: EuConstructionVatAccounts
  goods_transfer: GoodsTransfer
  createdGoodsTransferAccount: AccountGoodsTransfer | null
  updatedGoodsTransferStatus: "idle" | "loading" | "success" | "error"
  dataToUpdateAccountingSoftware: ResponseDataUpdateAccountingSoftware
}

interface VatAccounts {
  rates: Rate[]
  possibleBuyAccounts: Account[]
  possibleSellAccounts: Account[]
  selectedAccounts: SelectedAccount[]
  assignMode: VatAssignMode
  accountNumberLimit: number | null
}

interface EuConstructionVatAccounts {
  selected_account: Account | null
  possible_accounts: Account[]
  prefix: string[]
  forbid: string[]
  userAccountInstructions?: Instructions[]
}

export function companySettingsReducer(
  state = companySettingsInitialState,
  action: CompanySettingsActionsType
): CompanySettingsState {
  switch (action.type) {
    case CompanySettingsActionsEnum.GET_COMPANY_VAT_ACCOUNTS_SETTINGS_ATTEMPT:
      return { ...state }
    case CompanySettingsActionsEnum.GET_COMPANY_VAT_ACCOUNTS_SETTINGS_SUCCESS:
      return { ...state, ...action.payload }

    case CompanySettingsActionsEnum.GET_MY_UNISOFT_TOKEN_SUCCESS:
      return { ...state, myUnisoftToken: action.payload.myUnisoftToken }

    case CompanySettingsActionsEnum.UPDATE_MY_UNISOFT_TOKEN_SUCCESS:
      return { ...state, myUnisoftToken: action.payload.myUnisoftToken }

    case CompanySettingsActionsEnum.CREATE_ACCOUNT_RESET:
      return {
        ...state,
        createdAccount: null,
        createdEuConstructionVatAccount: null,
      }
    case CompanySettingsActionsEnum.CREATE_ACCOUNT_SUCCESS: {
      const buyOrSell = action.payload.createdAccount.buyOrSell
      const newVatAccounts =
        buyOrSell === "buy"
          ? {
              ...state,
              possibleBuyAccounts: [
                action.payload.createdAccount,
                ...state.possibleBuyAccounts,
              ],
            }
          : {
              ...state,
              possibleSellAccounts: [
                action.payload.createdAccount,
                ...state.possibleSellAccounts,
              ],
            }
      return {
        ...newVatAccounts,
        createdAccount: action.payload.createdAccount,
      }
    }
    case CompanySettingsActionsEnum.GET_COMPANY_EU_CONSTRUCTION_VAT_ACCOUNTS_SETTINGS_ATTEMPT:
      return { ...state }
    case CompanySettingsActionsEnum.GET_COMPANY_EU_CONSTRUCTION_VAT_ACCOUNTS_SETTINGS_SUCCESS:
      return { ...state, ...action.payload }
    case CompanySettingsActionsEnum.CREATE_EU_CONSTRUCTION_VAT_ACCOUNTS_SUCCESS: {
      const vatType = action.payload.createdEuConstructionVatAccount.vatType
      const newEuConstructionVatAccounts =
        vatType === "construction_vat"
          ? {
              ...state,
              construction_vat: {
                ...state.construction_vat,
                possible_accounts: [
                  ...state.construction_vat.possible_accounts,
                  action.payload.createdEuConstructionVatAccount,
                ],
              },
            }
          : vatType === "construction_reverse_vat"
          ? {
              ...state,
              construction_reverse_vat: {
                ...state.construction_reverse_vat,
                possible_accounts: [
                  ...state.construction_reverse_vat.possible_accounts,
                  action.payload.createdEuConstructionVatAccount,
                ],
              },
            }
          : vatType === "eu_vat"
          ? {
              ...state,
              eu_vat: {
                ...state.eu_vat,
                possible_accounts: [
                  ...state.eu_vat.possible_accounts,
                  action.payload.createdEuConstructionVatAccount,
                ],
              },
            }
          : {
              ...state,
              eu_reverse_vat: {
                ...state.eu_reverse_vat,
                possible_accounts: [
                  ...state.eu_reverse_vat.possible_accounts,
                  action.payload.createdEuConstructionVatAccount,
                ],
              },
            }
      return {
        ...newEuConstructionVatAccounts,
        createdEuConstructionVatAccount:
          action.payload.createdEuConstructionVatAccount,
      }
    }
    case CompanySettingsActionsEnum.GET_COMPANY_EU_CONSTRUCTION_VAT_ACCOUNTS_HISTORY_SUCCESS: {
      const vatType = action.payload.vatType
      const newEuConstructionVatAccounts =
        vatType === "construction_vat"
          ? {
              ...state,
              construction_vat: {
                ...state.construction_vat,
                userAccountInstructions: action.payload.userAccountInstructions,
              },
            }
          : vatType === "construction_reverse_vat"
          ? {
              ...state,
              construction_reverse_vat: {
                ...state.construction_reverse_vat,
                userAccountInstructions: action.payload.userAccountInstructions,
              },
            }
          : vatType === "eu_vat"
          ? {
              ...state,
              eu_vat: {
                ...state.eu_vat,
                userAccountInstructions: action.payload.userAccountInstructions,
              },
            }
          : {
              ...state,
              eu_reverse_vat: {
                ...state.eu_reverse_vat,
                userAccountInstructions: action.payload.userAccountInstructions,
              },
            }
      return {
        ...newEuConstructionVatAccounts,
      }
    }
    case CompanySettingsActionsEnum.GET_COMPANY_GOODS_TRANSFER_ACCOUNTS_SUCCESS: {
      return {
        ...state,
        goods_transfer: action.goodsPayload,
        accountNumberLimit: action.accountNumberLimit,
        rates: action.vat_rates,
      }
    }
    case CompanySettingsActionsEnum.UPDATE_GOODS_TRANSFER_ACCOUNTS_ATTEMPT:
      return {
        ...state,
        updatedGoodsTransferStatus: "loading",
      }
    case CompanySettingsActionsEnum.UPDATE_GOODS_TRANSFER_ACCOUNTS_SUCCESS:
      return {
        ...state,
        updatedGoodsTransferStatus: "success",
      }
    case CompanySettingsActionsEnum.UPDATE_GOODS_TRANSFER_ACCOUNTS_FAILURE:
      return {
        ...state,
        updatedGoodsTransferStatus: "error",
      }
    case CompanySettingsActionsEnum.UPDATE_GOODS_TRANSFER_ACCOUNTS_RESET:
      return {
        ...state,
        updatedGoodsTransferStatus: "idle",
      }
    case CompanySettingsActionsEnum.CREATE_GOODS_TRANSFER_ACCOUNT_SUCCESS: {
      return {
        ...state,
        createdGoodsTransferAccount: action.newAccount,
      }
    }
    case CompanySettingsActionsEnum.CREATE_GOODS_TRANSFER_ACCOUNT_RESET: {
      return {
        ...state,
        createdGoodsTransferAccount: null,
      }
    }
    case CompanySettingsActionsEnum.CREATE_GOODS_TRANSFER_ACCOUNT_WITH_VAT_SUCCESS: {
      return {
        ...state,
        goods_transfer: {
          ...state.goods_transfer,
          commission_account_vat_rates: {
            ...state.goods_transfer.commission_account_vat_rates,
            [action.goodsType]: action.commissions,
          },
        },
      }
    }
    case CompanySettingsActionsEnum.DESTROY_COMMISSION_ACCOUNT_VAT_RATE_SUCCESS: {
      return {
        ...state,
        goods_transfer: {
          ...state.goods_transfer,
          commission_account_vat_rates: {
            ...state.goods_transfer.commission_account_vat_rates,
            [action.goodsType]: action.commissions,
          },
        },
      }
    }
    case CompanySettingsActionsEnum.GET_DATA_TO_UPDATE_ACCOUNTING_SOFTWARE_ATTEMPT: {
      return {
        ...state,
      }
    }
    case CompanySettingsActionsEnum.GET_DATA_TO_UPDATE_ACCOUNTING_SOFTWARE_SUCCESS: {
      return {
        ...state,
        dataToUpdateAccountingSoftware: action.data,
      }
    }

    default:
      return { ...state }
  }
}

export interface Account {
  id: number
  details: string
  number: string
}

interface SelectedAccountPayload {
  vat_accounting: "per_rate" | "unique"
  buy_or_sell: "buy" | "sell"
  vat_rate_id: number | null
  account_id: number
}

export interface VatAccountPayload {
  vat_accounting: "per_rate" | "unique"
  buy_or_sell: "buy" | "sell"
  vat_rate_id: number | null
  company_id: number
  account_id: number | null
}

interface SelectedAccount {
  vatAccounting: "per_rate" | "unique"
  buyOrSell: "buy" | "sell"
  vatRateId: number | null
  accountId: number
}

interface Rate {
  id: number
  rate: string
}

interface VatAccountSettings {
  disable_vat_accounts: boolean
  possible_buy_accounts: Account[]
  possible_sell_accounts: Account[]
  selected_vat_accounts: SelectedAccountPayload[]
  vat_rates: Rate[]
  account_number_limit: number | null
}

interface EuConstructionVatAccountSettings {
  construction_vat: EuConstructionVatAccounts
  construction_reverse_vat: EuConstructionVatAccounts
  eu_vat: EuConstructionVatAccounts
  eu_reverse_vat: EuConstructionVatAccounts
}

interface EuConstructionVatAccountHistory {
  user_account_instructions: Instructions[]
}

export interface Instructions {
  account_number: string
  created_at: string
  instruction_type: string
  user: string
  metadata: {
    [index: string]: string
  }
}

export type VatAssignMode = "no_vat" | "per_rate" | "unique"

export const getVatAccountSettingsThunk =
  ({ companyId }: { companyId: number }) =>
  (dispatch: Dispatch<CompanySettingsActionsType>) => {
    dispatch(getCompanyVatAccountsSettingsAttemptAction())
    return axios
      .get<VatAccountSettings>(`/companies/vat_accounts`, {
        params: { id: companyId },
      })
      .then((response) => {
        const assignMode =
          response.data.disable_vat_accounts ||
          response.data.selected_vat_accounts.length === 0
            ? "no_vat"
            : response.data.selected_vat_accounts[0].vat_accounting

        dispatch(
          getCompanyVatAccountsSettingsSuccessAction({
            rates: response.data.vat_rates,
            possibleBuyAccounts: response.data.possible_buy_accounts,
            possibleSellAccounts: response.data.possible_sell_accounts,
            selectedAccounts: response.data.selected_vat_accounts.map(
              (acc) => ({
                accountId: acc.account_id,
                vatAccounting: acc.vat_accounting,
                buyOrSell: acc.buy_or_sell,
                vatRateId: acc.vat_rate_id,
              })
            ),
            assignMode,
            accountNumberLimit: response.data.account_number_limit,
          })
        )
      })
      .catch(() => {
        dispatch(getCompanyVatAccountsSettingsErrorAction())
      })
  }

export const updateVatSettingsThunk =
  ({
    companyId,
    assignMode,
    accounts,
  }: {
    companyId: number
    assignMode: VatAssignMode
    accounts: VatAccountPayload[]
  }) =>
  (dispatch: Dispatch<CompanySettingsActionsType | RNBThunkAction>) => {
    if (assignMode === "no_vat") {
      dispatch(disableVatAccountsAttemptAction())
      return axios
        .post(`companies/disable_vat_accounts`, {
          id: companyId,
        })
        .then((response) => {
          dispatch(disableVatAccountsSuccessAction())
          dispatch(getVatAccountSettingsThunk({ companyId }))
        })
        .catch((e) => {
          dispatch(disableVatAccountsErrorAction())
        })
    }

    dispatch(createVatAccountsAttemptAction())
    return axios
      .post(`companies/create_vat_accounts`, {
        id: companyId,
        vat_accounts: accounts,
      })
      .then((response) => {
        dispatch(createVatAccountsSuccessAction())
        dispatch(getVatAccountSettingsThunk({ companyId }))
      })
      .catch((e) => {
        dispatch(createVatAccountsErrorAction())
      })
  }

export const getEuConstructionVatAccountSettingsThunk =
  ({ companyId }: { companyId: number }) =>
  (dispatch: Dispatch<CompanySettingsActionsType>) => {
    dispatch(getCompanyEuConstructionVatAccountsSettingsAttemptAction())

    return axios
      .get<EuConstructionVatAccountSettings>(
        `/companies/eu_construction_vat_accounts`,
        {
          params: { id: companyId },
        }
      )
      .then((response) => {
        const res = response.data
        dispatch(
          getCompanyEuConstructionVatAccountsSettingsSuccessAction({
            construction_vat: {
              selected_account: res.construction_vat.selected_account,
              possible_accounts: res.construction_vat.possible_accounts,
              prefix: res.construction_vat.prefix,
              forbid: res.construction_vat.forbid,
            },
            construction_reverse_vat: {
              selected_account: res.construction_reverse_vat.selected_account,
              possible_accounts: res.construction_reverse_vat.possible_accounts,
              prefix: res.construction_reverse_vat.prefix,
              forbid: res.construction_reverse_vat.forbid,
            },
            eu_vat: {
              selected_account: res.eu_vat.selected_account,
              possible_accounts: res.eu_vat.possible_accounts,
              prefix: res.eu_vat.prefix,
              forbid: res.eu_vat.forbid,
            },
            eu_reverse_vat: {
              selected_account: res.eu_reverse_vat.selected_account,
              possible_accounts: res.eu_reverse_vat.possible_accounts,
              prefix: res.eu_reverse_vat.prefix,
              forbid: res.eu_reverse_vat.forbid,
            },
          })
        )
      })
      .catch(() => {
        dispatch(getCompanyEuConstructionVatAccountsSettingsErrorAction())
      })
  }

export const getEuConstructionVatAccountHistoryThunk =
  ({ companyId, vatType }: { companyId: number; vatType: vatType }) =>
  (dispatch: Dispatch<CompanySettingsActionsType>) => {
    dispatch(getCompanyEuConstructionVatAccountsHistoryAttemptAction())

    return axios
      .get<EuConstructionVatAccountHistory>(
        `/companies/eu_construction_vat_accounts_history`,
        {
          params: { id: companyId, vat_type: vatType },
        }
      )
      .then((response) => {
        const res = response.data
        const parsed_response = res.user_account_instructions.map((curr) => ({
          ...curr,
          metadata: JSON.parse(String(curr.metadata)),
        }))

        dispatch(
          getCompanyEuConstructionVatAccountsHistorySuccessAction({
            userAccountInstructions: parsed_response,
            vatType: vatType,
          })
        )
      })
      .catch(() => {
        dispatch(getCompanyEuConstructionVatAccountsHistoryErrorAction())
      })
  }

export const updateEuConstructionVatSettingsThunk =
  ({
    companyId,
    accounts,
  }: {
    companyId: number
    accounts: EuConstructionVatAccountsState
  }) =>
  (dispatch: Dispatch<CompanySettingsActionsType | RNBThunkAction>) => {
    dispatch(updateEuConstructionVatAccountsAttemptAction())
    return axios
      .post(`companies/update_eu_construction_vat_accounts`, {
        id: companyId,
        eu_vat_account_id: accounts.euVatAccount?.id,
        eu_reverse_vat_account_id: accounts.euReverseVatAccount?.id,
        construction_vat_account_id: accounts.constructionVatAccount?.id,
        construction_reverse_vat_account_id:
          accounts.constructionReverseVatAccount?.id,
      })
      .then((response) => {
        dispatch(updateEuConstructionVatAccountsSuccessAction())

        dispatch(getEuConstructionVatAccountSettingsThunk({ companyId }))
      })
      .catch((e) => {
        dispatch(updateEuConstructionVatAccountsErrorAction())
      })
  }

interface CreatedAccount extends Account {
  buyOrSell: buyOrSell
  vatRateId: number | null
}

export type vatType =
  | "construction_vat"
  | "construction_reverse_vat"
  | "eu_vat"
  | "eu_reverse_vat"

interface CreatedEuConstructionVatAccount extends Account {
  vatType: vatType | null
}

export const createAccountThunk =
  ({
    companyId,
    number,
    details,
    buyOrSell,
    vatRateId,
  }: {
    companyId: number
    number: string
    details: string
    buyOrSell: buyOrSell
    vatRateId: number | null
  }) =>
  (dispatch: Dispatch<CompanySettingsActionsType>) => {
    return axios
      .post<Account | true>(`/companies/create_account`, {
        id: companyId,
        number,
        details,
        buy_or_sell: buyOrSell,
      })
      .then((response) => {
        if (response.data === true) {
          dispatch(createAccountDuplicateError())
          return
        }
        dispatch(
          createAccountSuccessAction({ ...response.data, buyOrSell, vatRateId })
        )
        dispatch(createAccountSuccessToaster())
      })
      .catch(() => {})
  }

export const createEuConstructionVatAccountThunk =
  ({
    companyId,
    number,
    details,
    vatType,
  }: {
    companyId: number
    number: string
    details: string
    vatType: vatType | null
  }) =>
  (dispatch: Dispatch<CompanySettingsActionsType>) => {
    dispatch(createEuConstructionVatAccountsAttemptAction())
    return axios
      .post<Account | true>(`/companies/create_eu_construction_vat_account`, {
        id: companyId,
        number,
        details,
        vat_type: vatType,
      })
      .then((response) => {
        if (response.data === true) {
          dispatch(createAccountDuplicateError())
          return
        }
        dispatch(
          createEuConstructionVatAccountsSuccessAction({
            ...response.data,
            vatType,
          })
        )
        dispatch(createAccountSuccessToaster())
      })
      .catch(() => {
        dispatch(createEuConstructionVatAccountsErrorAction())
      })
  }

interface MyUnisoftTokenRespone {
  my_unisoft_token: string | null
}

export const getMyUnisoftTokenThunk =
  ({ companyId }: { companyId: number }) =>
  (dispatch: Dispatch<CompanySettingsActionsType>) => {
    dispatch(getMyUnisoftTokenAttemptAction())

    return axios
      .get<MyUnisoftTokenRespone>(`/companies/get_my_unisoft_token`, {
        params: {
          id: companyId,
        },
      })
      .then((response) => {
        const token = response.data.my_unisoft_token
        dispatch(getMyUnisoftTokenSuccessAction(token || ""))
      })
      .catch(() => {
        dispatch(getMyUnisoftTokenErrorAction())
      })
  }

export const updateMyUnisoftTokenThunk =
  ({ companyId, token }: { companyId: number; token: string }) =>
  (dispatch: Dispatch<CompanySettingsActionsType>) => {
    dispatch(updateMyUnisoftTokenAttemptAction())

    return axios
      .put<MyUnisoftTokenRespone>(`/companies/update_my_unisoft_token`, {
        id: companyId,
        token,
      })
      .then(() => {
        dispatch(updateMyUnisoftTokenSuccessAction(token))
      })
      .catch(() => {
        dispatch(updateMyUnisoftTokenErrorAction())
      })
  }

export const GetCompanyGoodsTransferAccountsThunk =
  (companyId: number) => (dispatch: Dispatch<CompanySettingsActionsType>) => {
    dispatch(GetCompanyGoodsTransferAccountsAttempt())

    return axios
      .get<GoodsTransferResponse>(
        `/companies/get_goods_transfer_accounts_for_user`,
        {
          params: { id: companyId },
        }
      )
      .then((response) => {
        const goods = {
          commission_account_vat_rates:
            response.data.commission_account_vat_rates,
          enum_translations: response.data.enum_translations,
          goods_transfer_commission_type_enum:
            response.data.goods_transfer_commission_type_enum,
          goods_transfer_type_enum: response.data.goods_transfer_type_enum,
          possible_goods_transfer_accounts:
            response.data.possible_goods_transfer_accounts,
          possible_goods_transfer_commission_accounts:
            response.data.possible_goods_transfer_commission_accounts,
          selected_accounts: response.data.selected_accounts,
          goods_transfer_rules: response.data.goods_transfer_rules,
          goods_transfer_commission_rules:
            response.data.goods_transfer_commission_rules,
        }

        dispatch(
          GetCompanyGoodsTransferAccountsSuccess(
            goods,
            response.data.account_number_limit,
            response.data.vat_rates
          )
        )
      })
      .catch(() => {
        dispatch(GetCompanyGoodsTransferAccountsFailure())
      })
  }

interface GoodsTransfer {
  commission_account_vat_rates: { [index: string]: CommissionAccountVatRate[] }
  enum_translations: EnumTranslations | null
  goods_transfer_commission_type_enum: GoodsTransferType[]
  goods_transfer_type_enum: GoodsTransferType[]
  possible_goods_transfer_accounts: Account[]
  possible_goods_transfer_commission_accounts: Account[]
  selected_accounts: SelectedGoodsTransferAccounts | null
  goods_transfer_rules: string[]
  goods_transfer_commission_rules: string[]
}

interface GoodsTransferResponse extends GoodsTransfer {
  account_number_limit: number | null
  vat_rates: Rate[]
}

export interface CommissionAccountVatRate {
  id: number
  account_id: number
  number: string
  details: string
  rate: number
}

export type SelectedGoodsTransferAccounts = {
  [K in GoodsTransferType]: AccountGoodsTransfer | null
}

export interface AccountGoodsTransfer extends Account {
  instructions: AccountInstructions[] | null
  type: GoodsTransferType
}

export interface AccountInstructions {
  created_at: string
  instruction_type: string
  metadata: {}
  email: string
  account_number: number
}

export type EnumTranslations = {
  [K in GoodsTransferType]: string
}

export type GoodsTransferType =
  | "draw_games_goods_transfer"
  | "draw_games_goods_transfer_commission"
  | "draw_games_paid_lots_goods_transfer"
  | "metro_goods_transfer"
  | "metro_goods_transfer_commission"
  | "monetics_goods_transfer"
  | "monetics_goods_transfer_commission"
  | "other_goods_transfer"
  | "other_goods_transfer_commission"
  | "postage_stamps_goods_transfer"
  | "postage_stamps_goods_transfer_commission"
  | "press_goods_transfer"
  | "press_goods_transfer_commission"
  | "scratch_games_goods_transfer"
  | "scratch_games_goods_transfer_commission"
  | "scratch_games_paid_lots_goods_transfer"
  | "tax_stamps_goods_transfer"
  | "tax_stamps_goods_transfer_commission"
  | "tobacco_goods_transfer"
  | "tobacco_goods_transfer_commission"

export const UpdateGoodsTransferAccountsThunk =
  (companyId: number, accounts: { [index: string]: Account | null }) =>
  (dispatch: Dispatch<CompanySettingsActionsType | RNBThunkAction>) => {
    dispatch(UpdateGoodsTransferAccountsAttempt())

    return axios
      .post(`/companies/set_goods_transfer_accounts`, {
        id: companyId,
        accounts: accounts,
      })
      .then(() => {
        dispatch(UpdateGoodsTransferAccountsSuccess())
        dispatch(GetCompanyGoodsTransferAccountsThunk(companyId))
      })
      .catch(() => {
        dispatch(UpdateGoodsTransferAccountsFailure())
      })
  }

export const CreateGoodsTransferAccountThunk =
  (
    companyId: number,
    account: { number: number; details: string },
    goods_type: string
  ) =>
  (dispatch: Dispatch<CompanySettingsActionsType | RNBThunkAction>) => {
    dispatch(CreateGoodsTransferAccountAttempt())

    return axios
      .post<AccountGoodsTransfer>(`/companies/create_goods_transfer_account`, {
        id: companyId,
        account: account,
        goods_type: goods_type,
      })
      .then((response) => {
        dispatch(GetCompanyGoodsTransferAccountsThunk(companyId))
        dispatch(CreateGoodsTransferAccountSuccess(response.data))
      })
      .catch(() => {
        dispatch(CreateGoodsTransferAccountFailure())
      })
  }

export const CreateGoodsTransferAccountWithVathunk =
  (
    companyId: number,
    account: { number: string; details: string },
    goods_type: string,
    vat_rate_id: string
  ) =>
  (dispatch: Dispatch<CompanySettingsActionsType>) => {
    dispatch(CreateGoodsTransferAccountWithVatAttempt())

    return axios
      .post<CommissionAccountVatRate[]>(
        `/companies/create_commission_account_vat_rate`,
        {
          id: companyId,
          account: account,
          datum_type: goods_type,
          vat_rate_id: vat_rate_id,
        }
      )
      .then((response) => {
        dispatch(
          CreateGoodsTransferAccountWithVatSuccess(response.data, goods_type)
        )
      })
      .catch(() => {
        dispatch(CreateGoodsTransferAccountWithVatFailure())
      })
  }

export const DestroyCommissionAccountVatRateThunk =
  (
    companyId: number,
    goods_type: string,
    commission_account_vat_rate_id: number
  ) =>
  (dispatch: Dispatch<CompanySettingsActionsType>) => {
    dispatch(DestroyCommissionAccountVatRateAttempt())

    return axios
      .post<CommissionAccountVatRate[]>(
        `/companies/destroy_commission_account_vat_rate`,
        {
          id: companyId,
          commission_account_vat_rate_id: commission_account_vat_rate_id,
          datum_type: goods_type,
        }
      )
      .then((response) => {
        dispatch(
          DestroyCommissionAccountVatRateSuccess(response.data, goods_type)
        )
      })
      .catch(() => {
        dispatch(DestroyCommissionAccountVatRateFailure())
      })
  }

export const GetDataToUpdateAccountingSoftwareThunk =
  (
    companyId: number,
    accounting_software: string,
    buy_auxiliary_prefix: string,
    sell_auxiliary_prefix: string
  ) =>
  (dispatch: Dispatch<CompanySettingsActionsType>) => {
    dispatch(GetDataToUpdateAccountingSoftwareAttempt())
    return axios
      .get<ResponseDataUpdateAccountingSoftware>(
        `/companies/data_to_update_accounting_software`,
        {
          params: {
            id: companyId,
            accounting_software: accounting_software,
            buy_auxiliary_prefix: buy_auxiliary_prefix,
            sell_auxiliary_prefix: sell_auxiliary_prefix,
          },
        }
      )
      .then((response) => {
        dispatch(GetDataToUpdateAccountingSoftwareSuccess(response.data))
      })
      .catch(() => {
        dispatch(GetDataToUpdateAccountingSoftwareFailure())
      })
  }

interface ResponseDataUpdateAccountingSoftware {
  length_rules: {
    max_account_number_length: number | null
    max_code_length: number | null
  }
  codes_too_long: CodesToUpdate[] | []
  accounts_too_long: AccountsToUpdate[] | []
  all_accounts: AccountsToUpdate[] | []
  all_codes: CodesToUpdate[] | []
  accounting_software_prefix: { buy: string; sell: string } | null
  auxiliary_or_principal: AuxiliaryOrPrincipal
  software_events: SoftwareEvent[] | []
}

interface CodesToUpdate {
  id: number
  code: string
}
interface AccountsToUpdate {
  id: number
  number: string
}

export type AuxiliaryOrPrincipal =
  | ["auxiliary"]
  | ["principal"]
  | ["auxiliary", "principal"]
  | null

export interface SoftwareEvent {
  id: number
  date: string
  email: string
  metadata: { [index: string]: string }
}
